import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp } from '../../../../components/common/Helpers';

const heading = Loadable(() => isFuncComp() ? import('../../FuncContainers/heading') : import('../../containers/web/heading'));
export default MapTo('vcg/components/soe-home/react/contactinfo/heading')(heading);
